import React from "react";
import {Box, Typography} from "@mui/material";
import {alpha, useTheme} from "@mui/material/styles";
import {Check} from "lucide-react";
import {PHASE_MILESTONES} from "./trackingConfig";

const StepMarker = ({index, isDone, isCurrent}) => {
    const theme = useTheme();
    return (
        <Box sx={{
            position: "relative",
            zIndex: 1,
            width: 24,
            height: 24,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: isDone ? "primary.main" : isCurrent ? "background.paper" : "neutral.100",
            border: isCurrent ? 2 : 0,
            borderColor: "primary.main",
            boxShadow: isCurrent ? `0 0 0 4px ${alpha(theme.palette.primary.main, 0.14)}` : "none"
        }}>
            {/*{isDone ? <Check size={13} strokeWidth={3} color={theme.palette.background.paper}/> : (*/}
            {/*    <Typography variant="caption" sx={{*/}
            {/*        fontSize: 12,*/}
            {/*        fontWeight: 700,*/}
            {/*        color: isCurrent ? "primary.main" : "neutral.500"*/}
            {/*    }}>{index + 1}</Typography>*/}
            {/*)}*/}
            {isDone ? <Check size={13} strokeWidth={3} color={theme.palette.background.paper} /> : isCurrent ? (
                <Box sx={{width: 8, height: 8, borderRadius: "50%", backgroundColor: "primary.main"}} />
            ) : (
                <Typography variant="caption" sx={{fontSize: 12, fontWeight: 700, color: "neutral.500"}}>{index + 1}</Typography>
            )}
        </Box>
    );
};

const MobileMilestones = ({milestones, currentIndex}) => (
    <Box sx={{display: {xs: "grid", sm: "none"}, gap: 0}}>
        {milestones.map((milestone, index) => {
            const isCurrent = index === currentIndex;
            const lastDoneIndex = milestones.map(m => m.done).lastIndexOf(true);
            return (
                <Box key={milestone.label} sx={{
                    display: "grid",
                    gridTemplateColumns: "24px minmax(0, 1fr)",
                    columnGap: 1.25,
                    minHeight: index === milestones.length - 1 ? 38 : 50
                }}>
                    <Box sx={{position: "relative", display: "flex", justifyContent: "center"}}>
                        <StepMarker index={index} isDone={milestone.done} isCurrent={isCurrent}/>
                        {index < milestones.length - 1 ? <Box sx={{
                            position: "absolute",
                            top: 24,
                            bottom: 0,
                            width: 2,
                            backgroundColor: milestone.done ? "primary.main" : "neutral.200",
                            // backgroundColor: (milestone.done && index !== lastDoneIndex) ? "primary.main" : "neutral.200"
                        }}/> : null}
                    </Box>
                    <Box sx={{pt: 0.125}}>
                        <Typography variant="subtitle2" sx={{
                            fontSize: 14,
                            lineHeight: 1.35,
                            color: isCurrent ? "primary.main" : milestone.done ? "text.primary" : "neutral.500"
                        }}>{milestone.label}</Typography>
                        <Typography variant="caption" sx={{
                            display: "block",
                            mt: 0.125,
                            color: "neutral.500"
                        }}>{milestone.date || "Pending"}</Typography>
                    </Box>
                </Box>
            );
        })}
    </Box>
);

const DesktopMilestones = ({milestones, currentIndex}) => {
    const theme = useTheme();
    return (
        <Box sx={{display: {xs: "none", sm: "flex"}, position: "relative", justifyContent: "space-between"}}>
            {milestones.map((milestone, index) => {
                const isCurrent = index === currentIndex;
                const lastDoneIndex = milestones.map(m => m.done).lastIndexOf(true);
                return (
                    <Box key={milestone.label} sx={{
                        position: "relative",
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        textAlign: "center"
                    }}>
                        {index > 0 ? <Box sx={{
                            position: "absolute",
                            top: 11,
                            left: 0,
                            right: "50%",
                            height: 2,
                            backgroundColor: milestones[index - 1].done ? "primary.main" : "neutral.200",
                            // backgroundColor: (milestone.done && index !== lastDoneIndex) ? "primary.main" : "neutral.200"
                        }}/> : null}
                        {index < milestones.length - 1 ? <Box sx={{
                            position: "absolute",
                            top: 11,
                            left: "50%",
                            right: 0,
                            height: 2,
                            backgroundColor: milestone.done ? "primary.main" : "neutral.200",
                            // backgroundColor: (milestone.done && index !== lastDoneIndex) ? "primary.main" : "neutral.200"
                        }}/> : null}
                        <StepMarker index={index} isDone={milestone.done} isCurrent={isCurrent}/>
                        <Typography variant="subtitle2" sx={{
                            mt: 1,
                            fontSize: 12,
                            fontWeight: 500,
                            color: isCurrent ? "primary.main" : milestone.done ? "text.primary" : "neutral.400"
                        }}>{milestone.label}</Typography>
                        <Typography variant="caption" sx={{
                            mt: 0.35,
                            minHeight: 16,
                            fontSize: 11,
                            lineHeight: "16px",
                            fontWeight: 500,
                            color: theme.palette.neutral[500]
                        }}>{milestone.date || ""}</Typography>
                    </Box>
                );
            })}
        </Box>
    );
};

export const TrackingMilestoneStepper = ({milestones}) => {
    const lastOccurred = milestones.reduce((last, milestone, index) => (milestone.done ? index : last), -1);
    // 停在持续阶段时这一步就是"进行中"；停在瞬间事件时该步已完成，绿点落到下一步
    const currentIndex = PHASE_MILESTONES.has(milestones[lastOccurred]?.label)
        ? lastOccurred
        : milestones.findIndex((milestone) => !milestone.done);
    // 进行中的那一步不画勾，交给绿点样式
    const steps = milestones.map((milestone, index) => ({
        ...milestone,
        done: milestone.done && index !== currentIndex
    }));
    return <><MobileMilestones milestones={steps} currentIndex={currentIndex}/><DesktopMilestones milestones={steps}
                                                                                                  currentIndex={currentIndex}/></>;

    // const currentIndex = milestones.findIndex((milestone) => !milestone.done);
    // return <><MobileMilestones milestones={milestones} currentIndex={currentIndex}/><DesktopMilestones
    //     milestones={milestones} currentIndex={currentIndex}/></>;
};
